import { FC, useState } from 'react';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import ToggleSection from 'components/ToggleSection/ToggleSection';
import axiosInstance from 'apis/axiosInstance';
import { renderToast } from 'components/Toast/Toast';

interface BlockSchedulingToggleSectionProps {
  control: any;
  setIsAllowed?: React.Dispatch<React.SetStateAction<boolean>>;
}

const BlockSchedulingToggleSection: FC<BlockSchedulingToggleSectionProps> = ({
  control,
  setIsAllowed,
}) => {
  const [isModalDisplayed, setIsModalDisplayed] = useState(false);
  const [isBlockSchedulingEnabled, setIsBlockSchedulingEnabled] =
    useState(false);

  const onChange = (value: boolean) => {
    setIsModalDisplayed(true);
    setIsAllowed?.(false);
    setIsBlockSchedulingEnabled(value);
  };

  const onConfirm = async () => {
    try {
      await axiosInstance.patch('/clinics/block-scheduling-setting', {
        isBlockSchedulingEnabled,
      });
      renderToast({
        type: 'success',
        message: 'Block scheduling mode enabled successfully',
      });
      setIsModalDisplayed(false);
      window.location.reload();
    } catch (error) {
      renderToast({
        type: 'error',
        message: 'Something went wrong. Please try again later',
      });
    }
  };

  return (
    <>
      {isModalDisplayed && (
        <ConfirmationModal
          title={`${isBlockSchedulingEnabled ? 'Enable' : 'Disable'} block scheduling mode?`}
          description={
            <div className="text-14 leading-[2.1rem] mt-1.6">
              <p>
                {isBlockSchedulingEnabled
                  ? 'Turn this on will enable block scheduling and refresh the current page to the new mode'
                  : 'Turn this off will disable block scheduling and refresh the current page to the new mode'}
              </p>
              <p className="mt-1">Do you want to continue?</p>
            </div>
          }
          onClose={() => {
            setIsModalDisplayed(false);
            setIsAllowed?.(true);
          }}
          onSubmit={onConfirm}
          submitBtnTitle={isBlockSchedulingEnabled ? 'Enable' : 'Disable'}
          enabledClickOutsideOrEsc={false}
        />
      )}
      <ToggleSection
        control={control}
        name="isBlockSchedulingEnabled"
        title="Block Scheduling Mode"
        onChange={onChange}
      />
    </>
  );
};

export default BlockSchedulingToggleSection;
